module.exports = __webpack_public_path__ + "img/core-first-2.314cc208.png";